export enum DIALOG_TYPE {
  REMOVE_MESSAGE_CONFIRMATION = 'REMOVE_MESSAGE_CONFIRMATION',
  ADD_ACCOUNT = 'ADD_ACCOUNT',
  FUNNEL_TRACKING_CREATE = 'FUNNEL_TRACKING_CREATE',
  FUNNEL_TRACKING_EDIT = 'FUNNEL_TRACKING_EDIT',
  FUNNEL_TRACKING_DELETE = 'FUNNEL_TRACKING_DELETE',
  SELECT_TIME_POPUP = 'SELECT_TIME_POPUP',
  MESSAGE_MEDIA_SELECTION = 'MESSAGE_MEDIA_SELECTION',
  VAULT_MEDIA_PREVIEW = 'VAULT_MEDIA_PREVIEW',
  RUN_OMM_WITHDRAW_DIALOG = 'RUN_OMM_WITHDRAW_DIALOG',
  BLACKLISTED_WORD_USAGE_DETECTION = 'BLACKLISTED_WORD_USAGE_DETECTION',
  ADD_CREATOR = 'ADD_CREATOR',
  CONFIRMATION = 'CONFIRMATION',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  FAN_SPEND_COLOR = 'FAN_SPEND_COLOR',
  COLOR_PICKER = 'COLOR_PICKER',
  DELETE_FAN_SPEND_COLOR = 'DELETE_FAN_SPEND_COLOR',
  IMAGE_SELECTOR = 'IMAGE_SELECTOR',
  TIERS_DIALOG = 'TIERS_DIALOG',
  REMOVE_TIER_DIALOG = 'REMOVE_TIER_DIALOG',

  /** Tiktok Research */
  DELETE_TIKTOK_LIST_DIALOG = 'DELETE_TIKTOK_LIST_DIALOG',
  CREATE_OR_EDIT_TIKTOK_LIST_DIALOG = 'CREATE_OR_EDIT_TIKTOK_LIST_DIALOG',
  MORE_TIKTOK_VIDEO_OR_SOUNDS_DIALOG = 'MORE_TIKTOK_VIDEO_OR_SOUNDS_DIALOG',
  CONTENT_TYPE_TIKTOK_FILTERS_DIALOG = 'CONTENT_TYPE_TIKTOK_FILTERS_DIALOG',
  STATISTICS_TIKTOK_FILTERS_DIALOG = 'STATISTICS_TIKTOK_FILTERS_DIALOG',
  STATISTICS_SOUNDS_FILTERS_DIALOG = 'STATISTICS_SOUNDS_FILTERS_DIALOG',
  ADD_TO_TIKTOK_LIST_DIALOG = 'ADD_TO_TIKTOK_LIST_DIALOG',

  /** OMM Operations */
  START_OMM_DIALOG = 'START_OMM_DIALOG',
  STOP_OMM_DIALOG = 'STOP_OMM_DIALOG',
  RESUME_OMM_DIALOG = 'RESUME_OMM_DIALOG',
  WITHDRAW_OMM_DIALOG = 'WITHDRAW_OMM_DIALOG',
  PAUSE_OMM_DIALOG = 'PAUSE_OMM_DIALOG',

  /** Campaigns */
  CHRISTMAS_PROMOTION = 'CHRISTMAS_PROMOTION',
  BLACK_FRIDAY_PROMOTION = 'BLACK_FRIDAY_PROMOTION',

  /** Chatting UI */
  SUMMARIZE_CHAT = 'SUMMARIZE_CHAT',
  CHAT_SUMMARY = 'CHAT_SUMMARY',
  CHAT_SUMMARIZE_PROGRESS = 'CHAT_SUMMARIZE_PROGRESS',
  LOAD_GIF = 'LOAD_GIF',
  MASS_MESSAGE_STATISTICS = 'MASS_MESSAGE_STATISTICS',
  EDIT_FAN_ORIGIN = 'EDIT_FAN_ORIGIN',
  DELETE_FAN_ORIGIN = 'DELETE_FAN_ORIGIN',
  UNSAVED_SALES_TEMPLATE = 'UNSAVED_SALES_TEMPLATE',
  CREATE_SALES_TEMPLATE = 'CREATE_SALES_TEMPLATE',
  EDIT_SALES_TEMPLATE = 'EDIT_SALES_TEMPLATE',
  DELETE_SALES_TEMPLATE = 'DELETE_SALES_TEMPLATE',
  NO_SPENDER_LIST_FORM = 'NO_SPENDER_LIST_FORM',
  NO_SPENDER_LIST_VIEW_FANS = 'NO_SPENDER_LIST_VIEW_FANS',
  RECENT_SPENDER_LIST_FORM = 'RECENT_SPENDER_LIST_FORM',
  DELETE_RECENT_SPENDER_LIST = 'DELETE_RECENT_SPENDER_LIST',
  CUSTOM_LIST_FORM = 'CUSTOM_LIST_FORM',
  CUSTOM_LIST_VIEW_FANS = 'CUSTOM_LIST_VIEW_FANS',
  CUSTOM_LIST_DELETE = 'CUSTOM_LIST_DELETE',
  EDIT_TIMEZONE = 'EDIT_TIMEZONE',
  MEDIA_PREVIEW = 'MEDIA_PREVIEW',
  ACCOUNTING_ADDITIONAL_COST_TYPE_CREATE = 'ACCOUNTING_ADDITIONAL_COST_TYPE_CREATE',
  ACCOUNTING_ADDITIONAL_COST_TYPE_DELETE = 'ACCOUNTING_ADDITIONAL_COST_TYPE_DELETE',
  ACCOUNTING_ADDITIONAL_COST_TYPES = 'ACCOUNTING_ADDITIONAL_COST_TYPES',
  ADD_ADDITIONAL_COST = 'ADD_ADDITIONAL_COST',
  ADDITIONAL_COST_DETAILS = 'ADDITIONAL_COST_DETAILS',
  SET_CREATOR_SALARY = 'SET_CREATOR_SALARY',
  SET_MEMBER_SALARY = 'SET_MEMBER_SALARY',
  ADD_PROSPECT = 'ADD_PROSPECT',
  BIRTHDAY_EDIT = 'BIRTHDAY_EDIT',
  MUTE_CHAT = 'MUTE_CHAT',
  CHAT_PRICE = 'CHAT_PRICE',
  SELECT_MEDIA_FROM_VAULT = 'SELECT_MEDIA_FROM_VAULT',
  ADD_MEDIA = 'ADD_MEDIA',
  VAULT_RENAME_CATEGORY = 'VAULT_RENAME_CATEGORY',
  VAULT_DELETE_CATEGORY = 'VAULT_DELETE_CATEGORY',
  VAULT_ADD_CATEGORY = 'VAULT_ADD_CATEGORY',
  MOVE_MEDIA = 'MOVE_MEDIA',
  DELETE_MEDIA = 'DELETE_MEDIA',
  MEDIA_SETTINGS = 'MEDIA_SETTINGS',
  PPV_TIMELINE = 'PPV_TIMELINE',
  CREATE_SCRIPTS_FOLDER = 'CREATE_SCRIPTS_FOLDER',
  EDIT_SCRIPTS_FOLDER = 'EDIT_SCRIPTS_FOLDER',
  COPY_SCRIPT = 'COPY_SCRIPT',
  REMOVE_SCRIPTS_FOLDER = 'REMOVE_SCRIPTS_FOLDER',
  NEW_MESSAGE = 'NEW_MESSAGE',
  FANS_LIST_TO_START_CHAT_WITH = 'FANS_LIST_TO_START_CHAT_WITH',
  ADD_AUDIO = 'ADD_AUDIO',
  EDIT_AUDIO = 'EDIT_AUDIO',
  DELETE_AUDIO = 'DELETE_AUDIO',
  UPLOAD_AUDIO = 'UPLOAD_AUDIO',
  COUNTDOWN = 'COUNTDOWN',
  LOGGED_OUT_OF = 'LOGGED_OUT_OF',
  CUI_INTRO = 'CUI_INTRO',
  BLOCK_USER = 'BLOCK_USER',
  RENAME_USER = 'RENAME_USER',
  PINNED_MESSAGES = 'PINNED_MESSAGES',
  MOBILE_TABS = 'MOBILE_TABS',
  COLLECTIONS = 'COLLECTIONS',
  RENAME_COLLECTION = 'RENAME_COLLECTION',
  CLEAR_COLLECTION_CONFIRMATION = 'CLEAR_COLLECTION_CONFIRMATION',
  DELETE_COLLECTION_CONFIRMATION = 'DELETE_COLLECTION_CONFIRMATION',
  CREATE_LIST = 'CREATE_LIST',
  CREATE_OPEN_CHATS_LIST = 'CREATE_OPEN_CHATS_LIST',
  OPEN_CHATS_LIST_CREATION_PROGRESS = 'OPEN_CHATS_LIST_CREATION_PROGRESS',
  PROMOTIONAL_OFFER_FOR_FAN = 'PROMOTIONAL_OFFER_FOR_FAN',
  TAG_OTHER_CREATORS_AND_RELEASE_FORMS = 'TAG_OTHER_CREATORS_AND_RELEASE_FORMS',
  SHOW_OTHER_CREATORS = 'SHOW_OTHER_CREATORS',
  INVITE_TAGGABLE_CREATOR = 'INVITE_TAGGABLE_CREATOR',
  SMART_GLOSSARY_AI_DIALOG = 'SMART_GLOSSARY_AI_DIALOG',
  CHAT_GALLERY = 'CHAT_GALLERY',
  SAVE_TO_LIST = 'SAVE_TO_LIST',
  NOTICE = 'NOTICE',
  DESKTOP_UPDATE_DIALOG = 'DESKTOP_UPDATE_DIALOG', // TODO: Remove this once we no longer receive error log from users
  TRANSLATION_CONFIG_DIALOG = 'TRANSLATION_CONFIG_DIALOG',

  CHAT_SUGGESTIONS = 'CHAT_SUGGESTIONS',
}

export const HIDE_ANIMATION_DURATION = 200
